<template>
    <stat-layout-card>
        <template #title>
            <h2 class="m-0">{{ data.title }}</h2>
        </template>
        <template #content>
            <div v-for="(stat, statIndex) in data.slots" :key="statIndex" class="stats-block">
                <a :href="stat.link" target="_blank" class="primary-50-hover cpointer gray-100">
                    <h3 class="stats-title">{{ stat.label }}</h3>
                    <div
                        v-for="(value, valueIndex) in dataToDisplay(stat.slots)"
                        :key="valueIndex"
                        class="data-block-number inline-block"
                    >
                        <h3 class="data-value">
                            {{
                                value.type == 'amount'
                                    ? $filters.numberFormat(value.value)
                                    : value.value
                            }}
                            {{ value.unit ? value.unit : '' }}
                        </h3>
                        <p class="data-label">{{ value.label }}</p>
                    </div>
                </a>
            </div>
        </template>
    </stat-layout-card>
</template>

<script>
import StatLayoutCard from './StatLayoutCard.vue';
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            labels: [],
        };
    },
    methods: {
        dataToDisplay(values) {
            return values.filter((value) => ['amount', 'count', 'margin'].includes(value.type));
        },
    },
    components: {
        StatLayoutCard,
    },
};
</script>

<style scoped></style>
